'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useAtomValue } from 'jotai';
import { pdpParamsWithSyncAtom } from '@/atoms/pdpParamsAtom';
import { Locale } from '@/utility/locale';
import { MpImageGallery, MpImageGalleryComposition } from '../MpImageGallery';
type MpImageGalleryProps = {
  locale: Locale;
  sellable: Sellable;
  initialAppearanceId: string;
  modelImages?: ModelImage[];
  composition: MpImageGalleryComposition;
  productType: ClientProductType;
  spacingFactor?: number;
  isSpreadBrand?: boolean;
  imageAltText?: string;
  isTemplate?: boolean;
};
export const MpImageGalleryWrapper = t0 => {
  const $ = _c(6);
  let initialAppearanceId;
  let props;
  if ($[0] !== t0) {
    ({
      initialAppearanceId,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = initialAppearanceId;
    $[2] = props;
  } else {
    initialAppearanceId = $[1];
    props = $[2];
  }
  const pdpParams = useAtomValue(pdpParamsWithSyncAtom);
  const appearanceId = pdpParams?.appearanceId ?? initialAppearanceId;
  let t1;
  if ($[3] !== appearanceId || $[4] !== props) {
    t1 = <MpImageGallery appearanceId={appearanceId} {...props} />;
    $[3] = appearanceId;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};